import { Link } from "react-router-dom";
import { useCurrency } from "../lib/currency";
import { ShieldCheck, ArrowUpRight, MapPin, PlayCircle } from "lucide-react";

export default function ListingCard({ listing }) {
  const { format } = useCurrency();
  return (
    <Link to={`/listing/${listing.id}`} data-testid={`listing-card-${listing.id}`} className="dv-card group block">
      <div className="relative aspect-[16/10] overflow-hidden bg-slate-100">
        {listing.image_url && <img src={listing.image_url} alt={listing.business_name} className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-500" />}
        <div className="absolute top-3 left-3 flex gap-2">
          <span className="dv-pill bg-white/95 text-slate-700">{listing.industry}</span>
          {listing.video_url && <span className="dv-pill bg-blue-600 text-white"><PlayCircle size={12} /> Video</span>}
        </div>
        {listing.featured && <div className="absolute top-3 right-3 dv-pill bg-amber-100 text-amber-700">Featured</div>}
      </div>
      <div className="p-5">
        <div className="flex items-start justify-between gap-3 mb-2">
          <h3 className="font-bold text-lg leading-snug text-slate-900">{listing.business_name}</h3>
          <ArrowUpRight size={18} className="text-slate-300 group-hover:text-blue-600 transition-colors flex-shrink-0 mt-1" />
        </div>
        <div className="flex items-center gap-1.5 text-slate-500 text-sm mb-4">
          <MapPin size={13} /> {listing.city ? `${listing.city}, ` : ""}{listing.country}
          {listing.verified && <span className="ml-2 text-emerald-600 inline-flex items-center gap-1"><ShieldCheck size={12} /> Verified</span>}
        </div>
        <div className="grid grid-cols-2 gap-3 pt-4 border-t border-slate-100">
          <div>
            <div className="text-[11px] font-medium text-slate-500 uppercase tracking-wide mb-1">{listing.listing_type === "investment" ? "Seeking" : "Asking"}</div>
            <div className="font-bold text-blue-600 text-lg">{format(listing.listing_type === "investment" ? listing.investment_requirement : listing.asking_price)}</div>
          </div>
          <div>
            <div className="text-[11px] font-medium text-slate-500 uppercase tracking-wide mb-1">Revenue</div>
            <div className="font-semibold text-slate-900 text-base">{listing.revenue_range}</div>
          </div>
        </div>
      </div>
    </Link>
  );
}
